// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AttendeesTable_tableContainer__iVLcA {
  border: 1px solid #d1d9e2;
  border-radius: 10px;
  overflow: hidden;
}
.AttendeesTable_table__E\\+vG1 {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
.AttendeesTable_scrollContainer__Qzv06 {
  overflow: hidden;
}
.AttendeesTable_tableHeaderRow__obJZz {
  background-color: #f8f9fb;
  height: 44px;
}
.AttendeesTable_headerCell__WbKWw {
  padding: 0px;
}
.AttendeesTable_headerCellLabel__zXWoD {
  color: rgba(95, 109, 126, 0.78);
  cursor: default;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  margin: 0px 0px 0px 24px;
  text-align: start;
}
.AttendeesTable_tableDataRow__ijrkt {
  border-top: 1px solid #d1d9e2;
  height: 64px;
}
.AttendeesTable_nameCell__GPLHk {
  align-items: center;
  column-gap: 16px;
  display: flex;
  height: 64px;
  padding-left: 24px;
  cursor: pointer;
}
.AttendeesTable_userPhoto__Ln2f8 {
  border-radius: 64px;
  height: 32px;
  width: 32px;
}
.AttendeesTable_emptyProfilePhoto__k46V- {
  align-items: center;
  background-color: #e2e2e2;
  border-radius: 64px;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
}
.AttendeesTable_profilePhotoIcon__9fVga {
  stroke: #5f6d7e;
}
.AttendeesTable_nameText__rfhSg {
  color: #5f6d7e;
  cursor: pointer;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  margin: 0px;
  text-transform: capitalize;
}
.AttendeesTable_programCell__mvbVC {
  padding-left: 24px;
}
.AttendeesTable_programCellContent__5b8RR {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
}
.AttendeesTable_programText__ZwlP9 {
  color: #5f6d7e;
  cursor: default;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  margin: 0px;
}
.AttendeesTable_groupText__qslMG {
  color: #7e818c;
  cursor: default;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  margin: 0px;
}
.AttendeesTable_emailCell__szcvJ {
  padding-left: 24px;
}
.AttendeesTable_emailLink__X0A2G {
  text-decoration: none;
}
.AttendeesTable_emailLink__X0A2G:hover {
  text-decoration: underline;
  text-decoration-color: #5f6d7e;
}
.AttendeesTable_emailText__vbCpC {
  color: #5f6d7e;
  cursor: pointer;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  margin: 0px;
}
.AttendeesTable_phoneCell__UqlQD {
  padding-left: 24px;
}
.AttendeesTable_phoneLink__MGuYa {
  text-decoration: none;
}
.AttendeesTable_phoneLink__MGuYa:hover {
  text-decoration: underline;
  text-decoration-color: #5f6d7e;
}
.AttendeesTable_phoneText__q95em {
  color: #5f6d7e;
  cursor: pointer;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  margin: 0px;
}
.AttendeesTable_removeItemButton__\\+\\+6eJ {
  align-items: center;
  background-color: #e2e2e2;
  border-radius: 64px;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
}
.AttendeesTable_removeItemIcon__sJkRU {
  height: 16px;
  stroke: #5f6d7e;
  width: 16px;
}
.AttendeesTable_archiveItemButton__O7rLR {
  align-items: center;
  background-color: #e2e2e2;
  border-radius: 64px;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
}
.AttendeesTable_tableBottomContainer__81l-f {
  align-items: center;
  background-color: #f8f9fb;
  border-top: 1px solid #d1d9e2;
  display: flex;
  justify-content: center;
  padding: 12px 0px;
  width: 100%;
}
.AttendeesTable_addAttendeeButton__79Xsv {
  align-items: center;
  background-color: #fff;
  border: 1px solid #d1d9e2;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  column-gap: 8px;
  height: 40px;
  justify-content: center;
  width: 200px;
}
.AttendeesTable_addAttendeeButtonText__eL\\+aD {
  color: #5f6d7e;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.AttendeesTable_addAttendeeButtonIcon__OmAi1 {
  stroke: #5f6d7e;
}

@media screen and (max-width: 950px) {
  .AttendeesTable_scrollContainer__Qzv06 {
    overflow: scroll;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/singleGroup/components/attendeesTable/AttendeesTable.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".tableContainer {\n  border: 1px solid #d1d9e2;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.table {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n}\n.scrollContainer {\n  overflow: hidden;\n}\n.tableHeaderRow {\n  background-color: #f8f9fb;\n  height: 44px;\n}\n.headerCell {\n  padding: 0px;\n}\n.headerCellLabel {\n  color: rgba(95, 109, 126, 0.78);\n  cursor: default;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  margin: 0px 0px 0px 24px;\n  text-align: start;\n}\n.tableDataRow {\n  border-top: 1px solid #d1d9e2;\n  height: 64px;\n}\n.nameCell {\n  align-items: center;\n  column-gap: 16px;\n  display: flex;\n  height: 64px;\n  padding-left: 24px;\n  cursor: pointer;\n}\n.userPhoto {\n  border-radius: 64px;\n  height: 32px;\n  width: 32px;\n}\n.emptyProfilePhoto {\n  align-items: center;\n  background-color: #e2e2e2;\n  border-radius: 64px;\n  display: flex;\n  height: 32px;\n  justify-content: center;\n  width: 32px;\n}\n.profilePhotoIcon {\n  stroke: #5f6d7e;\n}\n.nameText {\n  color: #5f6d7e;\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  margin: 0px;\n  text-transform: capitalize;\n}\n.programCell {\n  padding-left: 24px;\n}\n.programCellContent {\n  display: flex;\n  flex-direction: column;\n  row-gap: 4px;\n}\n.programText {\n  color: #5f6d7e;\n  cursor: default;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0em;\n  margin: 0px;\n}\n.groupText {\n  color: #7e818c;\n  cursor: default;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0em;\n  margin: 0px;\n}\n.emailCell {\n  padding-left: 24px;\n}\n.emailLink {\n  text-decoration: none;\n}\n.emailLink:hover {\n  text-decoration: underline;\n  text-decoration-color: #5f6d7e;\n}\n.emailText {\n  color: #5f6d7e;\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  margin: 0px;\n}\n.phoneCell {\n  padding-left: 24px;\n}\n.phoneLink {\n  text-decoration: none;\n}\n.phoneLink:hover {\n  text-decoration: underline;\n  text-decoration-color: #5f6d7e;\n}\n.phoneText {\n  color: #5f6d7e;\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  margin: 0px;\n}\n.removeItemButton {\n  align-items: center;\n  background-color: #e2e2e2;\n  border-radius: 64px;\n  cursor: pointer;\n  display: flex;\n  height: 32px;\n  justify-content: center;\n  width: 32px;\n}\n.removeItemIcon {\n  height: 16px;\n  stroke: #5f6d7e;\n  width: 16px;\n}\n.archiveItemButton {\n  align-items: center;\n  background-color: #e2e2e2;\n  border-radius: 64px;\n  cursor: pointer;\n  display: flex;\n  height: 32px;\n  justify-content: center;\n  width: 32px;\n}\n.tableBottomContainer {\n  align-items: center;\n  background-color: #f8f9fb;\n  border-top: 1px solid #d1d9e2;\n  display: flex;\n  justify-content: center;\n  padding: 12px 0px;\n  width: 100%;\n}\n.addAttendeeButton {\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #d1d9e2;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  column-gap: 8px;\n  height: 40px;\n  justify-content: center;\n  width: 200px;\n}\n.addAttendeeButtonText {\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.addAttendeeButtonIcon {\n  stroke: #5f6d7e;\n}\n\n@media screen and (max-width: 950px) {\n  .scrollContainer {\n    overflow: scroll;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `AttendeesTable_tableContainer__iVLcA`,
	"table": `AttendeesTable_table__E+vG1`,
	"scrollContainer": `AttendeesTable_scrollContainer__Qzv06`,
	"tableHeaderRow": `AttendeesTable_tableHeaderRow__obJZz`,
	"headerCell": `AttendeesTable_headerCell__WbKWw`,
	"headerCellLabel": `AttendeesTable_headerCellLabel__zXWoD`,
	"tableDataRow": `AttendeesTable_tableDataRow__ijrkt`,
	"nameCell": `AttendeesTable_nameCell__GPLHk`,
	"userPhoto": `AttendeesTable_userPhoto__Ln2f8`,
	"emptyProfilePhoto": `AttendeesTable_emptyProfilePhoto__k46V-`,
	"profilePhotoIcon": `AttendeesTable_profilePhotoIcon__9fVga`,
	"nameText": `AttendeesTable_nameText__rfhSg`,
	"programCell": `AttendeesTable_programCell__mvbVC`,
	"programCellContent": `AttendeesTable_programCellContent__5b8RR`,
	"programText": `AttendeesTable_programText__ZwlP9`,
	"groupText": `AttendeesTable_groupText__qslMG`,
	"emailCell": `AttendeesTable_emailCell__szcvJ`,
	"emailLink": `AttendeesTable_emailLink__X0A2G`,
	"emailText": `AttendeesTable_emailText__vbCpC`,
	"phoneCell": `AttendeesTable_phoneCell__UqlQD`,
	"phoneLink": `AttendeesTable_phoneLink__MGuYa`,
	"phoneText": `AttendeesTable_phoneText__q95em`,
	"removeItemButton": `AttendeesTable_removeItemButton__++6eJ`,
	"removeItemIcon": `AttendeesTable_removeItemIcon__sJkRU`,
	"archiveItemButton": `AttendeesTable_archiveItemButton__O7rLR`,
	"tableBottomContainer": `AttendeesTable_tableBottomContainer__81l-f`,
	"addAttendeeButton": `AttendeesTable_addAttendeeButton__79Xsv`,
	"addAttendeeButtonText": `AttendeesTable_addAttendeeButtonText__eL+aD`,
	"addAttendeeButtonIcon": `AttendeesTable_addAttendeeButtonIcon__OmAi1`
};
export default ___CSS_LOADER_EXPORT___;
